import { twMerge } from 'tailwind-merge';
import { clsx, type ClassValue } from 'clsx';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(...inputs));
}

export function formatPrice(price: number): string {
  if (price >= 1_000_000_000) {
    return `${(price / 1_000_000_000).toLocaleString('ru-RU', { maximumFractionDigits: 1 })} млрд ₽`;
  } else if (price >= 1_000_000) {
    return `${(price / 1_000_000).toLocaleString('ru-RU', { maximumFractionDigits: 1 })} млн ₽`;
  } else if (price >= 1_000) {
    return `${(price / 1_000).toLocaleString('ru-RU', { maximumFractionDigits: 0 })} тыс. ₽`;
  } else {
    return `${price.toLocaleString('ru-RU')} ₽`;
  }
}